const imgUrls = [
	"https://i.ibb.co/bL75gmN/05f70a878e0c.png",
	"https://i.ibb.co/f9vxTz8/23f6ab0525d5.png",
	"https://i.ibb.co/wRyY2CX/843d4f70c48a.png",
	"https://i.ibb.co/CbHZKhb/9ef7a94b289e.png",
	"https://i.ibb.co/rt9TSY7/8740db0e7e05.png",
	"https://i.ibb.co/pwQcNJX/cbfa4de560d7.png",
	"https://i.ibb.co/3NvZcqm/505f7a88f1cb.png",
	"https://i.ibb.co/Wt5MnQ9/81726328a3a1.png",
];

export default imgUrls;
